import React, { useEffect } from 'react'
import InterestPicker from '../InterestPicker'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { commonActions } from 'srcReact/components/actions'
import styles from './styles.module.scss'
import { createUpdateGroupActions } from 'srcReact/GroupPage'
import { appConstantSettings } from 'srcReact/appConstantSettings'

function AddGroupInterests({ groupId, groupType, groupName, interests, className, closeModal }) {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const {
    common: { selectedInterests },
    createUpdateGroup: { editSuccess, loading: addInterestLoading }
  } = useSelector((state) => state)

  useEffect(() => {
    dispatch(commonActions.updateSelectedInterests([]))
    setTimeout(() => {
      dispatch(commonActions.updateSelectedInterests(interests))
    }, 800)
    return () => {
      dispatch(createUpdateGroupActions.clearData())
    }
  }, [])

  useEffect(() => {
    if (editSuccess && !addInterestLoading) {
      if (closeModal) {
        closeModal()
      }
    }
  }, [editSuccess, addInterestLoading])

  const handleSave = () => {
    if (
      selectedInterests &&
      selectedInterests.length >= appConstantSettings.MIN_INTEREST_COUNT &&
      selectedInterests.length <= appConstantSettings.MAX_INTEREST_COUNT
    ) {
      const selectedInterstsIds = selectedInterests ? selectedInterests.map((i) => i.id).join(',') : ''
      dispatch(createUpdateGroupActions.editGroup(groupId, { interest_ids: selectedInterstsIds }))
    }
  }

  return (
    <div id='interestContainer' className={`${className} ${styles.container}`}>
      <h2 className={styles.groupName}>{groupName}</h2>
      <div>
        <InterestPicker
          origin='group_edit'
          entityId={groupId}
          componentType={groupType}
          containerCss={styles.interestPickerContainer}
          primaryButton={{
            text: t('global.save'),
            size: 'large',
            clickHandler: handleSave
          }}
        />
      </div>
    </div>
  )
}

export default AddGroupInterests
